import React, { useState } from "react";
import CardImg from "../../../../components/CardImg";
import {
  parseRace20Cards,
  race20CardImg,
  RACE20_SUITS,
} from "../../../diamondCasinoAllGames/race20/race20Cards";

const ICONS = `${import.meta.env.BASE_URL}img/cardIcons`;

/**
 * Race 20 live cards overlay — reference markup (styled by index.css `.race20 .casino-video-cards`):
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container >
 *   per suit: span(suit icon) " " span(card)… " " span[.k-margin](K card)
 * The shuffle handle toggles the cards; they are hidden while no card is dealt (first token "1").
 */
export default function Race20CardsOverlay({ normalizedResultData }) {
  const [showCards, setShowCards] = useState(true);
  const { cards, bySuit } = parseRace20Cards(normalizedResultData);
  if (!cards.length) return null;
  const hide = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div
        className="casino-cards-shuffle"
        onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}
      >
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {RACE20_SUITS.map((suit, si) => {
          const list = bySuit[suit.key];
          return (
            <React.Fragment key={suit.key}>
              {si > 0 && " "}
              <div>
                <span>
                  <img src={`${ICONS}/${suit.icon}.png`} alt="" />
                </span>{" "}
                {list.map((token, i) => (
                  <span key={i}>
                    <CardImg src={race20CardImg(token)} alt="" />
                  </span>
                ))}{" "}
                {list.length > 0 && (
                  <span className={list.length !== 5 ? "k-margin" : undefined}>
                    <CardImg src={race20CardImg(suit.king)} alt="" />
                  </span>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
